// import { Suspense } from "react";
import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const TasksRoutes: RouteObject = {
	path: "/tasks/*",
	children: [
		{
			index: true,
			lazy: async () => {
				const { TasksHome } = await import("@/components/Task/TasksHome");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							{/* <Suspense fallback={<TasksRoutesSkeleton />}> */}
							<TasksHome />
							{/* </Suspense> */}
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "tasks",
			lazy: async () => {
				const { TasksActive } = await import("@/components/Task/ActiveTasks");
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							{/* <Suspense fallback={<TasksRoutesSkeleton />}> */}
							<TasksActive />
							{/* </Suspense> */}
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
	],
};
